<div class="dashboard-container">

  <!-- KPI Cards Row -->
  <div class="kpi-row">
    @for (card of kpiCards; track card.label) {
      <div class="kpi-card" [routerLink]="card.routerLink ?? null" [class.clickable]="!!card.routerLink">
        <div class="kpi-content">
          <div class="kpi-text">
            <div class="kpi-value">{{ card.value }}</div>
            <div class="kpi-label">{{ card.label }}</div>
          </div>
          <div class="kpi-icon-wrapper" [style.background-color]="card.iconBg">
            <mat-icon [style.color]="card.iconColor">{{ card.icon }}</mat-icon>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Second Row: Recent Tasks + Recent Activity -->
  <div class="detail-row">

    <!-- Recent Tasks Table -->
    <mat-card class="detail-card">
      <mat-card-header>
        <mat-card-title class="card-title">
          <mat-icon class="card-title-icon">list_alt</mat-icon>
          Recent Tasks
        </mat-card-title>
        <a mat-button color="primary" routerLink="/app/tasks" class="view-all-link">View All</a>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="recentTasks" class="tasks-table">

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Task #</th>
            <td mat-cell *matCellDef="let row">
              <a class="task-link" [routerLink]="['/app/tasks', row.id]">#{{ row.id }}</a>
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">{{ row.type }}</td>
          </ng-container>

          <ng-container matColumnDef="dateReceived">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let row">{{ row.dateReceived | date:'MM/dd/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <app-status-indicator [statusText]="row.status"></app-status-indicator>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="taskDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: taskDisplayedColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data" [attr.colspan]="taskDisplayedColumns.length">
              No recent tasks.
            </td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>

    <!-- Recent Activity Feed -->
    <mat-card class="detail-card">
      <mat-card-header>
        <mat-card-title class="card-title">
          <mat-icon class="card-title-icon">history</mat-icon>
          Recent Activity
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="activity-list">
          @for (item of recentActivity; track item.id) {
            <li class="activity-item">
              <div class="activity-icon-wrapper">
                <mat-icon [style.color]="item.iconColor">{{ item.icon }}</mat-icon>
              </div>
              <div class="activity-body">
                <span class="activity-description">{{ item.description }}</span>
                <span class="activity-timestamp">{{ item.timestamp | date:'MM/dd/yyyy h:mm a' }}</span>
              </div>
            </li>
          }
        </ul>
      </mat-card-content>
    </mat-card>

  </div>
</div>
